import { createEventBus } from '@omni/events'

// One bus for the whole shell. Same-origin only — there are no federated
// remotes on foreign origins anymore (doc §8.2).
export const shellEvents = createEventBus()
